import { slvmonApi } from '../../clients/clients';
import {
  GetAverageApyBlockChainEnum,
  GetAverageApyRequest,
  GetUserPortfolioQpMaEfsBlockChainEnum,
  GetUserPortfolioQpMaEfsRequest,
} from '../../generated';

export type AverageApyParam = {
  days?: number;
};

export type UserPortfolioParam = {
  userAddress: string;
};

const getAverageApyKey = (params: AverageApyParam) => ['slvmon', 'apy', params] as const;

const getAverageApyFn =
  ({ ...params }: AverageApyParam) =>
  async () => {
    const request: GetAverageApyRequest = {
      blockChain: GetAverageApyBlockChainEnum.Monad,
      ...params,
    };
    return slvmonApi.getAverageApy(request);
  };

const getUserPortfolioKey = (params: UserPortfolioParam) => ['slvmon', 'portfolio', params] as const;

const getUserPortfolioFn =
  ({ ...params }: UserPortfolioParam) =>
  async () => {
    const request: GetUserPortfolioQpMaEfsRequest = {
      blockChain: GetUserPortfolioQpMaEfsBlockChainEnum.Monad,
      ...params,
    };
    return slvmonApi.getUserPortfolioQpMaEfs(request);
  };

export const slvmonQuery = {
  getAverageApyKey,
  getAverageApyFn,
  getUserPortfolioKey,
  getUserPortfolioFn,
};
